import React, { useEffect,  useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import FASParentChild from "../../../../../components/Tables/FASParentChild";
import { FilterMain } from "../../../../../Redux/Slice/login/loginSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "lucide-react";
import {
  BalanceOpBalNet,
  OpBalNetFan,
} from "../../../../../Redux/Slice/Fas/Financial Statement/BalanceSheet/BalanceSheetSlice";
import { useTheme } from "../../../../../Themecontext/Themecontext";
import FASparentMultipalChild from "../../../../../components/Tables/FASparentMultipalChild";

export default function Closing({ selectedIds, ToDate, Fromdate }) {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { OpBalNetdata } = useSelector((state) => state.BalanceSheetSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;

  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(
      FilterMain({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
      }),
    );
  }, [dispatch, Firm, FinancialYear]);

  useEffect(() => {
    dispatch(OpBalNetFan());
    dispatch(
      BalanceOpBalNet({
        Firm,
        Year: FinancialYear,
        selectedIds: selectedIds || "",
        Fromdate,
        ToDate,
      }),
    );
  }, [dispatch, Firm, FinancialYear, selectedIds, ToDate, Fromdate]);

  const getRows = OpBalNetdata?.ClosingDetail.map((label, index) => ({
    srNumber: index + 1,
    AcName: label.AcName,
    Groupseq: label.Groupseq,
    AcLaieName: label.AcLaieName,
    GroupMstName: label.GroupMstName,
    NetBalCrAmt: label.NetBalCrAmt,
    NetBalDrAmt: label.NetBalDrAmt,
  }));

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Ac Type",
      key: "AcLaieName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "AcGroup Name",
      key: "GroupMstName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Account Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "NetBalance Debit",
      key: "NetBalDrAmt",
      align: "right",
      format: true,
    },
    {
      label: "NetBalance Credit",
      key: "NetBalCrAmt",
      align: "right",
      format: true,
    },
  ];

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const formatIndianAmount = (value) => {
      const num = Number(value || 0);

      return num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;

    /* ================= TITLE ================= */
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");
    doc.text("Closing Statement", pageWidth / 2, 15, {
      align: "center",
    });

    doc.setLineWidth(0.5);
    doc.line(marginX, 18, pageWidth - marginX, 18);

    /* ================= FIRM NAME ================= */
    const firmName =
      DataMain?.Firm_List?.[0]?.GroupName ||
      DataMain?.Firm_Dtl?.[0]?.FirmName ||
      "";

    let yPos = 25;

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text(String(firmName).trim(), pageWidth / 2, yPos, {
      align: "center",
    });

    yPos += 10;

    /* ================= TABLE DATA ================= */
    const tableRows = getRows.map((row) => [
      row.srNumber,
      row.AcLaieName || "",
      row.GroupMstName || "",
      row.AcName || "",
      formatIndianAmount(row.NetBalDrAmt || 0).toLocaleString("en-IN"),
      formatIndianAmount(row.NetBalCrAmt || 0).toLocaleString("en-IN"),
    ]);

    /* ================= TOTAL ================= */
    const totalDebit = getRows.reduce(
      (sum, row) => sum + Number(row.NetBalDrAmt || 0),
      0,
    );

    const totalCredit = getRows.reduce(
      (sum, row) => sum + Number(row.NetBalCrAmt || 0),
      0,
    );
    tableRows.push([
      "",
      "",
      "",
      "TOTAL",
      totalDebit.toLocaleString("en-IN"),
      totalCredit.toLocaleString("en-IN"),
    ]);

    /* ================= TABLE ================= */
    autoTable(doc, {
      startY: yPos,

      head: [
        [
          "Sr No.",
          "Ac Type",
          "Ac Group Name",
          "Account Name",
          "Net Balance Debit",
          "Net Balance Credit",
        ],
      ],

      body: tableRows,
      theme: "grid",
      showHead: "everyPage",

      styles: {
        fontSize: 8,
        fontStyle: "bold",
        cellPadding: 2.5,
        valign: "middle",
        textColor: [0, 0, 0],
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
      },

      columnStyles: {
        0: { halign: "center", cellWidth: 18 },
        1: { halign: "left", cellWidth: 35 },
        2: { halign: "left", cellWidth: 55 },
        3: { halign: "left", cellWidth: 70 },
        4: { halign: "right", cellWidth: 40 },
        5: { halign: "right", cellWidth: 40 },
      },

      didParseCell(data) {
        const row = data.row.raw;

        if (row?.[3] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [230, 230, 230];
        }
      },

      didDrawPage() {
        const pageNo = doc.internal.getCurrentPageInfo().pageNumber;

        doc.setFontSize(8);
        doc.text(`Page ${pageNo}`, marginX, pageHeight - 5);
      },
      
    });

    /* ================= SAVE ================= */
    doc.save("Closing_Balance_Statement.pdf");
  };
  if (OpBalNetdata === "no" || OpBalNetdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "10px",
          }}
        >
          <button
            onClick={handleDownload}
            className="common-hover-btn"
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6,
              color:
                isdark === "light"
                  ? iscolour?.Colour11
                  : iscolourDark?.Colour12,
              border: "none",
              padding: "10px 16px",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              cursor: "pointer",
              fontWeight: "500",
              fontSize: "14px",
              height: "44px",
            }}
          >
            <Download size={16} />
            Download PDF
          </button>
        </div>
        <div
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
          }}
        >
          <div
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,

              padding: "14px",
              margin: 0,
              position: "relative",
              zIndex: 2,
            }}
          >
            <h2
              style={{
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
                fontWeight: "600",
              }}
            >
              CLOSING
            </h2>
          </div>

          {/* <FASparentMultipalChild
            data={getRows}
            columns={getColumns}
            externalTotals={OpBalNetdata?.Summary?.[0] || {}}
          /> */}

          <FASparentMultipalChild
            data={getRows}
            columns={getColumns}
            externalTotals={OpBalNetdata?.Summary?.[0] || {}}
          />
        </div>
      </div>
    </>
  );
}
